import { ref } from 'vue'
import api from '@/lib/api'

// Product keys mirror the backend contract (polarLogic.productEnvKey):
//   solo_monthly … enterprise_annual, seat_block, pack_50, pack_200, pack_600
const PRODUCT_KEY_RE = /^((solo|business|team|enterprise)_(monthly|annual)|seat_block|pack_(50|200|600))$/

export function usePolar() {
  const isRedirecting = ref(false)
  const error = ref('')

  // tier + interval convenience → product key
  function productKey(tierId, interval = 'month') {
    return `${tierId}_${interval === 'year' ? 'annual' : 'monthly'}`
  }

  async function redirectToCheckout(product) {
    if (!PRODUCT_KEY_RE.test(product)) {
      throw new Error(`Unknown product key: ${product}`)
    }
    isRedirecting.value = true
    error.value = ''
    try {
      const { data } = await api.get('/billing/checkout', { params: { product } })
      if (!data?.url) throw new Error('Polar did not return a checkout URL')
      window.location.assign(data.url)
    } catch (err) {
      error.value = err?.response?.data?.detail || err?.message || 'Failed to start checkout'
      isRedirecting.value = false
      throw err
    }
  }

  async function openPortal() {
    isRedirecting.value = true
    error.value = ''
    try {
      const { data } = await api.get('/billing/portal')
      if (!data?.url) throw new Error('Polar did not return a portal URL')
      window.location.assign(data.url)
    } catch (err) {
      error.value = err?.response?.data?.detail || err?.message || 'Failed to open billing portal'
      isRedirecting.value = false
      throw err
    }
  }

  return { isRedirecting, error, productKey, redirectToCheckout, openPortal }
}
